import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useDispatch } from 'react-redux';
import { setAuthFromKeycloak } from '../state/slices/authSlice';
import { jwtDecode, JwtPayload } from 'jwt-decode';

export interface AuthManagerProps {}

export const KeycloakAuthManager = ({}: AuthManagerProps) => {
  const auth = useAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!auth.isAuthenticated || !auth.user?.access_token) return;

    const interval = setInterval(() => {
      const decoded = jwtDecode<JwtPayload>(auth.user!.access_token);
      const expiresAt = decoded?.exp;
      const now = Math.floor(Date.now() / 1000);

      if (!expiresAt) {
        console.warn('Token missing expiry; skipping refresh check.');
        return;
      }

      if (expiresAt - now < 90) {
        console.log('Access token expiring soon. Attempting silent refresh...');

        auth
          .signinSilent()
          .then((newUser) => {
            if (!newUser) {
              console.warn('Silent sign-in returned null. Logging out...');
              auth.signoutRedirect();
              return;
            }

            dispatch(
              setAuthFromKeycloak({
                isKeycloak: true,
                access: {
                  access: newUser.access_token,
                  refresh: newUser.refresh_token,
                },
              }),
            );
          })
          .catch((err) => {
            console.error('Silent refresh failed', err);
            auth.signoutRedirect();
          });
      }
    }, 60000); // Check every minute

    return () => clearInterval(interval);
  }, [auth.isAuthenticated, auth.user, dispatch]);

  return null;
};
